module.exports = videojs